const DEFAULT_EXTENSIONS = [".psa", ".zip"];

export const hasValidExtension = (
  fileName: string,
  validExtensions = DEFAULT_EXTENSIONS,
): boolean => validExtensions.some((ext) => fileName.toLowerCase().endsWith(ext));

export const filterValidFiles = (
  files: File[],
  validExtensions = DEFAULT_EXTENSIONS,
): { valid: File[]; invalid: string[] } => {
  const valid: File[] = [];
  const invalid: string[] = [];

  for (const f of files) {
    if (hasValidExtension(f.name, validExtensions)) {
      valid.push(f);
    } else {
      invalid.push(f.name);
    }
  }

  return { valid, invalid };
};

export const mergeFilesWithDedup = (existing: File[], incoming: File[]): File[] => {
  const merged = [...existing];

  for (const file of incoming) {
    if (!merged.some((e) => e.name === file.name && e.size === file.size)) {
      merged.push(file);
    }
  }

  return merged;
};
